<template>
  <section role="main" class="content-body">
    <header class="page-header">
      <h2>賃居訪視表</h2>
      <div class="right-wrapper">
        <ol class="breadcrumbs">
          <li>
            <a href="/">
              <i class="fa fa-home"></i>
            </a>
          </li>
          <li><span>賃居訪視表</span></li>
        </ol>
      </div>
    </header>
    <!-- start: page -->
    <div class="col-md-12">
      <section class="panel">
        <header class="panel-heading">
          <div class="panel-actions">
            <a href="#" class="panel-action panel-action-toggle" data-panel-toggle></a>
          </div>
          <h1 class="panel-title">學生/房東資料</h1>
        </header>
        <div class="panel-body">
          <div class="form-group">
            <div class="group">
              <label class="col-sm-2">系所班級：</label>
              <div class="col-sm-4">{{item.deptName}}{{item.dradeClass}}</div>
            </div>
            <div class="group">
              <label class="col-sm-2">學　　號：</label>
              <div class="col-sm-4">{{stuId}}</div>
            </div>
          </div>
          <div class="form-group">
            <div class="group">
              <label class="col-sm-2">姓　　名：</label>
              <div class="col-sm-4">{{item.studentName}}</div>
            </div>
            <div class="group">
              <label class="col-sm-2 ">電　　話：</label>
              <div class="col-sm-4">{{item.phone}}</div>
            </div>
          </div>
          <div class="form-group">
            <div class="group">
              <label class="col-sm-2 ">賃居地址：</label>
              <div class="col-sm-10">
                <select v-model="form.addrCityId" @change="addrCityChange">
                  <option :value="null">--請選擇--</option>
                  <option v-for="(item, index) in cityList" :key="index" :value="item.value">
                    {{ item.text }}
                  </option>
                </select>
                <select v-model="form.addrAreaId">
                  <option :value="null">--請選擇--</option>
                  <option v-for="(item, index) in addrAreaList" :key="index" :value="item.value">
                    {{ item.text }}
                  </option>
                </select>　
                <input type="text" style="width: 40%" v-model="form.addr" />
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="group">
              <label class="col-sm-2 ">房東姓名：</label>
              <div class="col-sm-10">
                <input type="text" style="width: 60%" v-model="form.landlordName" />
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="group">
              <label class="col-sm-2 ">房東職業：</label>
              <div class="col-sm-10">
                <input type="text" style="width: 60%" v-model="form.landlordJob" />
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="group">
              <label class="col-sm-2">房東電話：</label>
              <div class="col-sm-10">
                <div class="radio-custom radio-primary">
                  <input id="landlordPhoneType_1" name="landlordPhoneType" type="radio" value="通訊軟體" v-model="form.landlordPhoneType" />
                  <label for="landlordPhoneType_1">通訊軟體　</label>
                </div>
                <div class="radio-custom radio-primary">
                  <input id="landlordPhoneType_2" name="landlordPhoneType" type="radio" value="聯絡電話" v-model="form.landlordPhoneType" />
                  <label for="landlordPhoneType_2">聯絡電話</label>　
                  <input type="text" style="width: 60%" v-model="form.landlordPhone" v-if="form.landlordPhoneType == '聯絡電話'" />
                </div>
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="group">
              <label class="col-sm-2 ">訪視方式<span class="required">*</span>：</label>
              <div class="col-sm-4">
                <div class="radio-custom radio-primary">
                  <input id="visitType_1" type="radio" value="實地訪視" v-model="form.visitType" />
                  <label for="visitType_1">實地訪視　</label>
                </div>
                <div class="radio-custom radio-primary">
                  <input id="visitType_2" type="radio" value="面談關懷詢問" v-model="form.visitType" />
                  <label for="visitType_2">面談關懷詢問</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <!-- 租屋安全自我檢核表 -->
    <div class="col-md-12" v-show="form.visitType=='實地訪視'">
      <section class="panel">
        <header class="panel-heading">
          <div class="panel-actions">
            <a href="#" class="panel-action panel-action-toggle" data-panel-toggle></a>
          </div>
          <h1 class="panel-title">租屋安全自我檢核表</h1>
        </header>
        <div class="panel-body">
          <div class="form-group">
            <div class="group">
              <label class="col-sm-2">消防安全<span class="required">*</span>：</label>
              <div class="col-sm-10" style="margin-left: -15px">
                <div class="col-sm-6">
                  <div class="radio-custom radio-primary">
                    <input id="check_1_1_1" type="radio" :value="true" v-model="display.check_1_1" disabled="disabled" />
                    <label for="check_1_1_1">是　</label>
                  </div>
                  <div class="radio-custom radio-primary">
                    <input id="check_1_1_2" type="radio" :value="false" v-model="display.check_1_1" disabled="disabled" />
                    <label for="check_1_1_2">否</label>
                  </div>
                  　1.機車停車場保持距離 (2分)
                </div>
                <div class="col-sm-6">
                  <div class="radio-custom radio-primary">
                    <input id="check_1_2_1" type="radio" :value="true" v-model="display.check_1_2" disabled="disabled" />
                    <label for="check_1_2_1">是　</label>
                  </div>
                  <div class="radio-custom radio-primary">
                    <input id="check_1_2_2" type="radio" :value="false" v-model="display.check_1_2" disabled="disabled" />
                    <label for="check_1_2_2">否</label>
                  </div>
                  　2.樓梯、走道出口通暢 (3分)
                  <br />
                </div>
                <div class="col-sm-6">
                  <div class="radio-custom radio-primary">
                    <input id="check_1_3_1" type="radio" :value="true" v-model="display.check_1_3" disabled="disabled" />
                    <label for="check_1_3_1">是　</label>
                  </div>
                  <div class="radio-custom radio-primary">
                    <input id="check_1_3_2" type="radio" :value="false" v-model="display.check_1_3" disabled="disabled" />
                    <label for="check_1_3_2">否</label>
                  </div>
                  　3.逃生門（窗）備有鑰匙 (2分)
                  <br />
                </div>
                <div class="col-sm-6">
                  <div class="radio-custom radio-primary">
                    <input id="check_1_4_1" type="radio" :value="true" v-model="display.check_1_4" disabled="disabled" />
                    <label for="check_1_4_1">是　</label>
                  </div>
                  <div class="radio-custom radio-primary">
                    <input id="check_1_4_2" type="radio" :value="false" v-model="display.check_1_4" disabled="disabled" />
                    <label for="check_1_4_2">否</label>
                  </div>
                  　4.逃生門（窗、梯）至少2處 (3分)
                  <br />
                </div>
                <div class="col-sm-6">
                  <div class="radio-custom radio-primary">
                    <input id="check_1_5_1" type="radio" :value="true" v-model="display.check_1_5" disabled="disabled" />
                    <label for="check_1_5_1">是　</label>
                  </div>
                  <div class="radio-custom radio-primary">
                    <input id="check_1_5_2" type="radio" :value="false" v-model="display.check_1_5" disabled="disabled" />
                    <label for="check_1_5_2">否</label>
                  </div>
                  　5.逃生門開啟狀況良好 (2分)
                  <br />
                </div>
                <div class="col-sm-6">
                  <div class="radio-custom radio-primary">
                    <input id="check_1_6_1" type="radio" :value="true" v-model="display.check_1_6" disabled="disabled" />
                    <label for="check_1_6_1">是　</label>
                  </div>
                  <div class="radio-custom radio-primary">
                    <input id="check_1_6_2" type="radio" :value="false" v-model="display.check_1_6" disabled="disabled" />
                    <label for="check_1_6_2">否</label>
                  </div>
                  　6.2F以上有緩降索或方便逃生 (2分)
                  <br />
                </div>
                <div class="col-sm-6">
                  <div class="radio-custom radio-primary">
                    <input id="check_1_7_1" type="radio" :value="true" v-model="display.check_1_7" disabled="disabled" />
                    <label for="check_1_7_1">是　</label>
                  </div>
                  <div class="radio-custom radio-primary">
                    <input id="check_1_7_2" type="radio" :value="false" v-model="display.check_1_7" disabled="disabled" />
                    <label for="check_1_7_2">否</label>
                  </div>
                  　7.有緊急照明燈 (3分)
                  <br />
                </div>
                <div class="col-sm-6">
                  <div class="radio-custom radio-primary">
                    <input id="check_1_8_1" type="radio" :value="true" v-model="display.check_1_8" disabled="disabled" />
                    <label for="check_1_8_1">是　</label>
                  </div>
                  <div class="radio-custom radio-primary">
                    <input id="check_1_8_2" type="radio" :value="false" v-model="display.check_1_8" disabled="disabled" />
                    <label for="check_1_8_2">否</label>
                  </div>
                  　8.有煙霧偵測器 (3分)
                  <br />
                </div>
                <div class="col-sm-6">
                  <div class="radio-custom radio-primary">
                    <input id="check_1_9_1" type="radio" :value="true" v-model="display.check_1_9" disabled="disabled" />
                    <label for="check_1_9_1">是　</label>
                  </div>
                  <div class="radio-custom radio-primary">
                    <input id="check_1_9_2" type="radio" :value="false" v-model="display.check_1_9" disabled="disabled" />
                    <label for="check_1_9_2">否</label>
                  </div>
                  　9.滅火器足夠且無過期 (3分)
                  <br />
                </div>
                <div class="col-sm-6">
                  <div class="radio-custom radio-primary">
                    <input id="check_1_10_1" type="radio" :value="true" v-model="display.check_1_10" disabled="disabled" />
                    <label for="check_1_10_1">是　</label>
                  </div>
                  <div class="radio-custom radio-primary">
                    <input id="check_1_10_2" type="radio" :value="false" v-model="display.check_1_10" disabled="disabled" />
                    <label for="check_1_10_2">否</label>
                  </div>
                  　10.有逃生指示 (3分)
                  <br />
                </div>
                <div class="col-sm-6">
                  <div class="radio-custom radio-primary">
                    <input id="check_1_11_1" type="radio" :value="true" v-model="display.check_1_11" disabled="disabled" />
                    <label for="check_1_11_1">是　</label>
                  </div>
                  <div class="radio-custom radio-primary">
                    <input id="check_1_11_2" type="radio" :value="false" v-model="display.check_1_11" disabled="disabled" />
                    <label for="check_1_11_2">否</label>
                  </div>
                  　11.應設而設有灑水設備 (2分)
                  <br />
                </div>
                <div class="col-sm-6">
                  <div class="radio-custom radio-primary">
                    <input id="check_1_12_1" type="radio" :value="true" v-model="display.check_1_12" disabled="disabled" />
                    <label for="check_1_12_1">是　</label>
                  </div>
                  <div class="radio-custom radio-primary">
                    <input id="check_1_12_2" type="radio" :value="false" v-model="display.check_1_12" disabled="disabled" />
                    <label for="check_1_12_2">否</label>
                  </div>
                  　12.防火巷道暢通 (3分)
                  <br />
                </div>
              </div>
            </div>
          </div>

          <div class="form-group">
            <div class="group">
              <label class="col-sm-2">電路安全<span class="required">*</span>：</label>
              <div class="col-sm-10" style="margin-left: -15px">
                <div class="col-sm-6">
                  <div class="radio-custom radio-primary">
                    <input id="check_2_1_1" type="radio" :value="true" v-model="display.check_2_1" disabled="disabled" />
                    <label for="check_2_1_1">是　</label>
                  </div>
                  <div class="radio-custom radio-primary">
                    <input id="check_2_1_2" type="radio" :value="false" v-model="display.check_2_1" disabled="disabled" />
                    <label for="check_2_1_2">否</label>
                  </div>
                  　1.電源開關安全 (2分)
                </div>
                <div class="col-sm-6">
                  <div class="radio-custom radio-primary">
                    <input id="check_2_2_1" type="radio" :value="true" v-model="display.check_2_2" disabled="disabled" />
                    <label for="check_2_2_1">是　</label>
                  </div>
                  <div class="radio-custom radio-primary">
                    <input id="check_2_2_2" type="radio" :value="false" v-model="display.check_2_2" disabled="disabled" />
                    <label for="check_2_2_2">否</label>
                  </div>
                  　2.電線無裸露老舊 (2分)
                </div>
                <div class="col-sm-6">
                  <div class="radio-custom radio-primary">
                    <input id="check_2_3_1" type="radio" :value="true" v-model="display.check_2_3" disabled="disabled" />
                    <label for="check_2_3_1">是　</label>
                  </div>
                  <div class="radio-custom radio-primary">
                    <input id="check_2_3_2" type="radio" :value="false" v-model="display.check_2_3" disabled="disabled" />
                    <label for="check_2_3_2">否</label>
                  </div>
                  　3.電源線路整齊 (2分)
                </div>
                <div class="col-sm-6">
                  <div class="radio-custom radio-primary">
                    <input id="check_2_4_1" type="radio" :value="true" v-model="display.check_2_4" disabled="disabled" />
                    <label for="check_2_4_1">是　</label>
                  </div>
                  <div class="radio-custom radio-primary">
                    <input id="check_2_4_2" type="radio" :value="false" v-model="display.check_2_4" disabled="disabled" />
                    <label for="check_2_4_2">否</label>
                  </div>
                  　4.插座數目充足（＞3處） (2分)
                </div>
                <div class="col-sm-6">
                  <div class="radio-custom radio-primary">
                    <input id="check_2_5_1" type="radio" :value="true" v-model="display.check_2_5" disabled="disabled" />
                    <label for="check_2_5_1">是　</label>
                  </div>
                  <div class="radio-custom radio-primary">
                    <input id="check_2_5_2" type="radio" :value="false" v-model="display.check_2_5" disabled="disabled" />
                    <label for="check_2_5_2">否</label>
                  </div>
                  　5.電源線路未綑綁避免過熱 (2分)
                </div>
                <div class="col-sm-6">
                  <div class="radio-custom radio-primary">
                    <input id="check_2_6_1" type="radio" :value="true" v-model="display.check_2_6" disabled="disabled" />
                    <label for="check_2_6_1">是　</label>
                  </div>
                  <div class="radio-custom radio-primary">
                    <input id="check_2_6_2" type="radio" :value="false" v-model="display.check_2_6" disabled="disabled" />
                    <label for="check_2_6_2">否</label>
                  </div>
                  　6.插座插頭狀況良好 (2分)
                </div>
              </div>
            </div>
          </div>

          <div class="form-group">
            <div class="group">
              <label class="col-sm-2">瓦斯安全<span class="required">*</span>：</label>
              <div class="col-sm-10" style="margin-left: -15px">
                <div class="col-sm-6">
                  <div class="radio-custom radio-primary">
                    <input id="check_3_1_1" type="radio" :value="true" v-model="display.check_3_1" disabled="disabled" />
                    <label for="check_3_1_1">是　</label>
                  </div>
                  <div class="radio-custom radio-primary">
                    <input id="check_3_1_2" type="radio" :value="false" v-model="display.check_3_1" disabled="disabled" />
                    <label for="check_3_1_2">否</label>
                  </div>
                  　1.使用電熱水器（是以下免填） (8分)
                </div>
                <div class="col-sm-6">
                  <div class="radio-custom radio-primary">
                    <input id="check_3_2_1" type="radio" :value="true" v-model="display.check_3_2" disabled="disabled" />
                    <label for="check_3_2_1">是　</label>
                  </div>
                  <div class="radio-custom radio-primary">
                    <input id="check_3_2_2" type="radio" :value="false" v-model="display.check_3_2" disabled="disabled" />
                    <label for="check_3_2_2">否</label>
                  </div>
                  　2.管線良好 (2分)
                </div>
                <div class="col-sm-6">
                  <div class="radio-custom radio-primary">
                    <input id="check_3_3_1" type="radio" :value="true" v-model="display.check_3_3" disabled="disabled" />
                    <label for="check_3_3_1">是　</label>
                  </div>
                  <div class="radio-custom radio-primary">
                    <input id="check_3_3_2" type="radio" :value="false" v-model="display.check_3_3" disabled="disabled" />
                    <label for="check_3_3_2">否</label>
                  </div>
                  　3.瓦斯熱水器置於室外 (2分)
                </div>
                <div class="col-sm-6">
                  <div class="radio-custom radio-primary">
                    <input id="check_3_4_1" type="radio" :value="true" v-model="display.check_3_4" disabled="disabled" />
                    <label for="check_3_4_1">是　</label>
                  </div>
                  <div class="radio-custom radio-primary">
                    <input id="check_3_4_2" type="radio" :value="false" v-model="display.check_3_4" disabled="disabled" />
                    <label for="check_3_4_2">否</label>
                  </div>
                  　4.熱水器通風良好 (2分)
                </div>
                <div class="col-sm-6">
                  <div class="radio-custom radio-primary">
                    <input id="check_3_5_1" type="radio" :value="true" v-model="display.check_3_5" disabled="disabled" />
                    <label for="check_3_5_1">是　</label>
                  </div>
                  <div class="radio-custom radio-primary">
                    <input id="check_3_5_2" type="radio" :value="false" v-model="display.check_3_5" disabled="disabled" />
                    <label for="check_3_5_2">否</label>
                  </div>
                  　5.瓦斯桶放置安全 (2分)
                </div>
              </div>
            </div>
          </div>

          <div class="form-group">
            <div class="group">
              <label class="col-sm-2">結構安全<span class="required">*</span>：</label>
              <div class="col-sm-10" style="margin-left: -15px">
                <div class="col-sm-6">
                  <div class="radio-custom radio-primary">
                    <input id="check_4_1_1" type="radio" :value="true" v-model="display.check_4_1" disabled="disabled" />
                    <label for="check_4_1_1">是　</label>
                  </div>
                  <div class="radio-custom radio-primary">
                    <input id="check_4_1_2" type="radio" :value="false" v-model="display.check_4_1" disabled="disabled" />
                    <label for="check_4_1_2">否</label>
                  </div>
                  　1.樑柱正常無傾斜 (1分)
                </div>
                <div class="col-sm-6">
                  <div class="radio-custom radio-primary">
                    <input id="check_4_2_1" type="radio" :value="true" v-model="display.check_4_2" disabled="disabled" />
                    <label for="check_4_2_1">是　</label>
                  </div>
                  <div class="radio-custom radio-primary">
                    <input id="check_4_2_2" type="radio" :value="false" v-model="display.check_4_2" disabled="disabled" />
                    <label for="check_4_2_2">否</label>
                  </div>
                  　2.牆壁無嚴重龜裂 (2分)
                </div>
                <div class="col-sm-6">
                  <div class="radio-custom radio-primary">
                    <input id="check_4_3_1" type="radio" :value="true" v-model="display.check_4_3" disabled="disabled" />
                    <label for="check_4_3_1">是　</label>
                  </div>
                  <div class="radio-custom radio-primary">
                    <input id="check_4_3_2" type="radio" :value="false" v-model="display.check_4_3" disabled="disabled" />
                    <label for="check_4_3_2">否</label>
                  </div>
                  　3.無嚴重壁癌 (2分)
                </div>
                <div class="col-sm-6">
                  <div class="radio-custom radio-primary">
                    <input id="check_4_4_1" type="radio" :value="true" v-model="display.check_4_4" disabled="disabled" />
                    <label for="check_4_4_1">是　</label>
                  </div>
                  <div class="radio-custom radio-primary">
                    <input id="check_4_4_2" type="radio" :value="false" v-model="display.check_4_4" disabled="disabled" />
                    <label for="check_4_4_2">否</label>
                  </div>
                  　4.天花板無嚴重漏水 (2分)
                </div>
                <div class="col-sm-6">
                  <div class="radio-custom radio-primary">
                    <input id="check_4_5_1" type="radio" :value="true" v-model="display.check_4_5" disabled="disabled" />
                    <label for="check_4_5_1">是　</label>
                  </div>
                  <div class="radio-custom radio-primary">
                    <input id="check_4_5_2" type="radio" :value="false" v-model="display.check_4_5" disabled="disabled" />
                    <label for="check_4_5_2">否</label>
                  </div>
                  　5.門窗正常無變形 (2分)
                </div>
                <div class="col-sm-6">
                  <div class="radio-custom radio-primary">
                    <input id="check_4_6_1" type="radio" :value="true" v-model="display.check_4_6" disabled="disabled" />
                    <label for="check_4_6_1">是　</label>
                  </div>
                  <div class="radio-custom radio-primary">
                    <input id="check_4_6_2" type="radio" :value="false" v-model="display.check_4_6" disabled="disabled" />
                    <label for="check_4_6_2">否</label>
                  </div>
                  　6.油漆無脫落 (2分)
                </div>
                <div class="col-sm-6">
                  <div class="radio-custom radio-primary">
                    <input id="check_4_7_1" type="radio" :value="true" v-model="display.check_4_7" disabled="disabled" />
                    <label for="check_4_7_1">是　</label>
                  </div>
                  <div class="radio-custom radio-primary">
                    <input id="check_4_7_2" type="radio" :value="false" v-model="display.check_4_7" disabled="disabled" />
                    <label for="check_4_7_2">否</label>
                  </div>
                  　7.地板正常無凹陷 (2分)
                </div>
              </div>
            </div>
          </div>

          <div class="form-group">
            <div class="group">
              <label class="col-sm-2">門戶安全<span class="required">*</span>：</label>
              <div class="col-sm-10" style="margin-left: -15px">
                <div class="col-sm-6">
                  <div class="radio-custom radio-primary">
                    <input id="check_5_1_1" type="radio" :value="true" v-model="display.check_5_1" disabled="disabled" />
                    <label for="check_5_1_1">是　</label>
                  </div>
                  <div class="radio-custom radio-primary">
                    <input id="check_5_1_2" type="radio" :value="false" v-model="display.check_5_1" disabled="disabled" />
                    <label for="check_5_1_2">否</label>
                  </div>
                  　1.人員出入單純 (2分)
                </div>
                <div class="col-sm-6">
                  <div class="radio-custom radio-primary">
                    <input id="check_5_2_1" type="radio" :value="true" v-model="display.check_5_2" disabled="disabled" />
                    <label for="check_5_2_1">是　</label>
                  </div>
                  <div class="radio-custom radio-primary">
                    <input id="check_5_2_2" type="radio" :value="false" v-model="display.check_5_2" disabled="disabled" />
                    <label for="check_5_2_2">否</label>
                  </div>
                  　2.有門禁或管理員 (2分)
                </div>
                <div class="col-sm-6">
                  <div class="radio-custom radio-primary">
                    <input id="check_5_3_1" type="radio" :value="true" v-model="display.check_5_3" disabled="disabled" />
                    <label for="check_5_3_1">是　</label>
                  </div>
                  <div class="radio-custom radio-primary">
                    <input id="check_5_3_2" type="radio" :value="false" v-model="display.check_5_3" disabled="disabled" />
                    <label for="check_5_3_2">否</label>
                  </div>
                  　3.為單一出入口 (2分)
                </div>
                <div class="col-sm-6">
                  <div class="radio-custom radio-primary">
                    <input id="check_5_4_1" type="radio" :value="true" v-model="display.check_5_4" disabled="disabled" />
                    <label for="check_5_4_1">是　</label>
                  </div>
                  <div class="radio-custom radio-primary">
                    <input id="check_5_4_2" type="radio" :value="false" v-model="display.check_5_4" disabled="disabled" />
                    <label for="check_5_4_2">否</label>
                  </div>
                  　4.使用刷卡（密碼）與上鎖 (2分)
                </div>
                <div class="col-sm-6">
                  <div class="radio-custom radio-primary">
                    <input id="check_5_5_1" type="radio" :value="true" v-model="display.check_5_5" disabled="disabled" />
                    <label for="check_5_5_1">是　</label>
                  </div>
                  <div class="radio-custom radio-primary">
                    <input id="check_5_5_2" type="radio" :value="false" v-model="display.check_5_5" disabled="disabled" />
                    <label for="check_5_5_2">否</label>
                  </div>
                  　5.設有監視器 (2分)
                </div>
                <div class="col-sm-6">
                  <div class="radio-custom radio-primary">
                    <input id="check_5_6_1" type="radio" :value="true" v-model="display.check_5_6" disabled="disabled" />
                    <label for="check_5_6_1">是　</label>
                  </div>
                  <div class="radio-custom radio-primary">
                    <input id="check_5_6_2" type="radio" :value="false" v-model="display.check_5_6" disabled="disabled" />
                    <label for="check_5_6_2">否</label>
                  </div>
                  　6.監視方位合宜 (2分)
                </div>
                <div class="col-sm-6">
                  <div class="radio-custom radio-primary">
                    <input id="check_5_7_1" type="radio" :value="true" v-model="display.check_5_7" disabled="disabled" />
                    <label for="check_5_7_1">是　</label>
                  </div>
                  <div class="radio-custom radio-primary">
                    <input id="check_5_7_2" type="radio" :value="false" v-model="display.check_5_7" disabled="disabled" />
                    <label for="check_5_7_2">否</label>
                  </div>
                  　7.共同出入大門隨手關門 (2分)
                </div>
                <div class="col-sm-6">
                  <div class="radio-custom radio-primary">
                    <input id="check_5_8_1" type="radio" :value="true" v-model="display.check_5_8" disabled="disabled" />
                    <label for="check_5_8_1">是　</label>
                  </div>
                  <div class="radio-custom radio-primary">
                    <input id="check_5_8_2" type="radio" :value="false" v-model="display.check_5_8" disabled="disabled" />
                    <label for="check_5_8_2">否</label>
                  </div>
                  　8.門鎖牢靠 (3分)
                </div>
              </div>
            </div>
          </div>

          <div class="form-group">
            <div class="group">
              <label class="col-sm-2">用水<span class="required">*</span>：</label>
              <div class="col-sm-10" style="margin-left: -15px">
                <div class="col-sm-6">
                  <div class="radio-custom radio-primary">
                    <input id="check_6_1_1" type="radio" :value="true" v-model="display.check_6_1" disabled="disabled" />
                    <label for="check_6_1_1">是　</label>
                  </div>
                  <div class="radio-custom radio-primary">
                    <input id="check_6_1_2" type="radio" :value="false" v-model="display.check_6_1" disabled="disabled" />
                    <label for="check_6_1_2">否</label>
                  </div>
                  　1.有提供自來水 (2分)
                </div>
                <div class="col-sm-6">
                  <div class="radio-custom radio-primary">
                    <input id="check_6_2_1" type="radio" :value="true" v-model="display.check_6_2" disabled="disabled" />
                    <label for="check_6_2_1">是　</label>
                  </div>
                  <div class="radio-custom radio-primary">
                    <input id="check_6_2_2" type="radio" :value="false" v-model="display.check_6_2" disabled="disabled" />
                    <label for="check_6_2_2">否</label>
                  </div>
                  　2.有提供過濾性飲水器 (2分)
                </div>
                <div class="col-sm-6">
                  <div class="radio-custom radio-primary">
                    <input id="check_6_3_1" type="radio" :value="true" v-model="display.check_6_3" disabled="disabled" />
                    <label for="check_6_3_1">是　</label>
                  </div>
                  <div class="radio-custom radio-primary">
                    <input id="check_6_3_2" type="radio" :value="false" v-model="display.check_6_3" disabled="disabled" />
                    <label for="check_6_3_2">否</label>
                  </div>
                  　3.使用地下水 (3分)
                </div>
                <div class="col-sm-6">
                  <div class="radio-custom radio-primary">
                    <input id="check_6_4_1" type="radio" :value="true" v-model="display.check_6_4" disabled="disabled" />
                    <label for="check_6_4_1">是　</label>
                  </div>
                  <div class="radio-custom radio-primary">
                    <input id="check_6_4_2" type="radio" :value="false" v-model="display.check_6_4" disabled="disabled" />
                    <label for="check_6_4_2">否</label>
                  </div>
                  　4.有提供外購之安全飲用水 (1分)
                </div>
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="group">
              <label class="col-sm-2">鄰居<span class="required">*</span>：</label>
              <div class="col-sm-10" style="margin-left: -15px">
                <div class="col-sm-6">
                  <div class="radio-custom radio-primary">
                    <input id="check_7_1_1" type="radio" :value="true" v-model="display.check_7_1" disabled="disabled" />
                    <label for="check_7_1_1">是　</label>
                  </div>
                  <div class="radio-custom radio-primary">
                    <input id="check_7_1_2" type="radio" :value="false" v-model="display.check_7_1" disabled="disabled" />
                    <label for="check_7_1_2">否</label>
                  </div>
                  　1.與房東互動良好 (2分)
                </div>
                <div class="col-sm-6">
                  <div class="radio-custom radio-primary">
                    <input id="check_7_2_1" type="radio" :value="true" v-model="display.check_7_2" disabled="disabled" />
                    <label for="check_7_2_1">是　</label>
                  </div>
                  <div class="radio-custom radio-primary">
                    <input id="check_7_2_2" type="radio" :value="false" v-model="display.check_7_2" disabled="disabled" />
                    <label for="check_7_2_2">否</label>
                  </div>
                  　2.無紛爭行為發生 (1分)
                </div>
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="group">
              <label class="col-sm-2">總分：</label>
              <div class="col-sm-10" style="margin-left: -15px">
                <label class="check-score">{{ display.checkScore }}</label>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <!-- 租屋環境及設施 -->
    <div class="col-md-12" v-show="form.visitType=='實地訪視'">
      <section class="panel">
        <header class="panel-heading">
          <div class="panel-actions">
            <a href="#" class="panel-action panel-action-toggle" data-panel-toggle></a>
          </div>
          <h1 class="panel-title">租屋環境及設施</h1>
        </header>
        <div class="panel-body">
          <div class="form-group">
            <label class="col-sm-3 ">類　　　型<span class="required">*</span></label>
            <div class="col-sm-9">
              <div class="radio-custom radio-primary">
                <input id="houseType_1" type="radio" value="套房" v-model="display.houseType" disabled="disabled" />
                <label for="houseType_1">套房　</label>
              </div>
              <div class="radio-custom radio-primary">
                <input id="houseType_2" type="radio" value="雅房" v-model="display.houseType" disabled="disabled" />
                <label for="houseType_2">雅房　</label>
              </div>
              <div class="radio-custom radio-primary">
                <input id="houseType_3" type="radio" value="整層包租" v-model="display.houseType" disabled="disabled" />
                <label for="houseType_3">整層包租　</label>
              </div>
              <div class="radio-custom radio-primary">
                <input id="houseType_4" type="radio" value="其他" v-model="display.houseType" disabled="disabled" />
                <label for="houseType_4">其他 <input type="text" id="houseTypeOtherText" v-model="display.houseTypeOtherText" v-if="display.houseType=='其他'" disabled="disabled" /></label>
              </div>
            </div>
          </div>
          <div class="form-group">
            <label class="col-sm-3 ">建　　　物<span class="required">*</span></label>
            <div class="col-sm-9">
              <div class="radio-custom radio-primary">
                <input id="houseBuild_1" type="radio" value="公寓" v-model="display.houseBuild" disabled="disabled" />
                <label for="houseBuild_1">公寓　</label>
              </div>
              <div class="radio-custom radio-primary">
                <input id="houseBuild_2" type="radio" value="大廈" v-model="display.houseBuild" disabled="disabled" />
                <label for="houseBuild_2">大廈　</label>
              </div>
              <div class="radio-custom radio-primary">
                <input id="houseBuild_3" type="radio" value="頂樓加蓋" v-model="display.houseBuild" disabled="disabled" />
                <label for="houseBuild_3">頂樓加蓋　</label>
              </div>
              <div class="radio-custom radio-primary">
                <input id="houseBuild_4" type="radio" value="透天" v-model="display.houseBuild" disabled="disabled" />
                <label for="houseBuild_4">透天</label>
              </div>
            </div>
          </div>
          <div class="form-group">
            <label class="col-sm-3 ">隔　　　間<span class="required">*</span></label>
            <div class="col-sm-9">
              <div class="radio-custom radio-primary">
                <input id="houseRoom_1" type="radio" value="水泥" v-model="display.houseRoom" disabled="disabled" />
                <label for="houseRoom_1">水泥　</label>
              </div>
              <div class="radio-custom radio-primary">
                <input id="houseRoom_2" type="radio" value="木板" v-model="display.houseRoom" disabled="disabled" />
                <label for="houseRoom_2">木板　</label>
              </div>
              <div class="radio-custom radio-primary">
                <input id="houseRoom_3" type="radio" value="防火建材" v-model="display.houseRoom" disabled="disabled" />
                <label for="houseRoom_3">防火建材</label>
              </div>
            </div>
          </div>
          <div class="form-group">
            <label class="col-sm-3 ">結　　　構<span class="required">*</span></label>
            <div class="col-sm-9">
              <div class="radio-custom radio-primary">
                <input id="houseStructure_1" type="radio" value="鋼筋混凝土(RC)" v-model="display.houseStructure" disabled="disabled" />
                <label for="houseStructure_1">鋼筋混凝土(RC)　</label>
              </div>
              <div class="radio-custom radio-primary">
                <input id="houseStructure_2" type="radio" value="鋼骨鋼筋混凝土(SRC)" v-model="display.houseStructure" disabled="disabled" />
                <label for="houseStructure_2">鋼骨鋼筋混凝土(SRC)　</label>
              </div>
              <div class="radio-custom radio-primary">
                <input id="houseStructure_3" type="radio" value="鋼骨(SS)" v-model="display.houseStructure" disabled="disabled" />
                <label for="houseStructure_3">鋼骨(SS)　</label>
              </div>
              <div class="radio-custom radio-primary">
                <input id="houseStructure_4" type="radio" value="木造" v-model="display.houseStructure" disabled="disabled" />
                <label for="houseStructure_4">木造　</label>
              </div>
              <div class="radio-custom radio-primary">
                <input id="houseStructure_5" type="radio" value="鐵皮屋" v-model="display.houseStructure" disabled="disabled" />
                <label for="houseStructure_5">鐵皮屋</label>
              </div>
            </div>
          </div>
          <div class="form-group">
            <label class="col-sm-3 ">樓　　　層<span class="required">*</span></label>
            <div class="col-sm-9">
              <label>總樓層 <input type="number" id="houseTotalFloor" min="0" size="5" v-model="display.houseTotalFloor" disabled="disabled" /> 樓之第 <input type="number" min="0" size="5" v-model="display.houseFloor" disabled="disabled" /> 樓</label>
            </div>
          </div>
          <div class="form-group">
            <label class="col-sm-3 ">屋　　　齡</label>
            <div class="col-sm-9">
              <label>大　約 <input type="number" id="houseAge" min="0" size="5" v-model="display.houseAge" disabled="disabled" /> 年</label>
            </div>
          </div>
          <div class="form-group">
            <label class="col-sm-3 ">坪　　　數<span class="required">*</span></label>
            <div class="col-sm-9">
              <label>使用約 <input type="number" id="houseFootage" min="0" size="5" v-model="display.houseFootage" disabled="disabled" /> 坪</label>
            </div>
          </div>
          <div class="form-group">
            <label class="col-sm-3 ">租　　　金<span class="required">*</span></label>
            <div class="col-sm-9">
              <div class="radio-custom radio-primary">
                <input id="houseRentType_1" type="radio" value="月繳" v-model="display.houseRentType" disabled="disabled" />
                <label for="houseRentType_1">月繳　</label>
              </div>
              <div class="radio-custom radio-primary">
                <input id="houseRentType_2" type="radio" value="期繳" v-model="display.houseRentType" disabled="disabled" />
                <label for="houseRentType_2">期繳　</label>
              </div>
              <div class="radio-custom radio-primary">
                <input id="houseRentType_3" type="radio" value="季繳" v-model="display.houseRentType" disabled="disabled" />
                <label for="houseRentType_3">季繳</label>
              </div>
              <input type="number" size="10" v-model="display.houseRent" disabled="disabled" />元
            </div>
          </div>
          <div class="form-group">
            <label class="col-sm-3 ">押　　　金<span class="required">*</span></label>
            <div class="col-sm-9">
              <div class="radio-custom radio-primary">
                <input id="houseHasDeposit_1" type="radio" :value="false" v-model="houseHasDeposit" />
                <label for="houseHasDeposit_1">免付　</label>
              </div>
              <div class="radio-custom radio-primary">
                <input id="houseHasDeposit_2" type="radio" :value="true" v-model="houseHasDeposit" />
                <label for="houseHasDeposit_2">需繳 <input type="number" id="houseDeposit" size="10" v-model="form.houseDeposit" :disabled="!houseHasDeposit"> 元</label>
              </div>
            </div>
          </div>
          <div class="form-group">
            <label class="col-sm-3 ">水　　　費<span class="required">*</span></label>
            <div class="col-sm-9">
              <div class="radio-custom radio-primary">
                <input id="houseHasWaterBill_1" type="radio" :value="false" v-model="houseHasWaterBill" disabled="disabled" />
                <label for="houseHasWaterBill_1">內含　</label>
              </div>
              <div class="radio-custom radio-primary">
                <input id="houseHasWaterBill_2" type="radio" :value="true" v-model="houseHasWaterBill" disabled="disabled" />
                <label for="houseHasWaterBill_2">
                  另付
                  <input type="number" id="houseWaterBill" size="10" v-model="display.houseWaterBill" disabled="disabled" />
                  元
                </label>
              </div>
            </div>
          </div>
          <div class="form-group">
            <label class="col-sm-3 ">電　　　費<span class="required">*</span></label>
            <div class="col-sm-9">
              <div class="radio-custom radio-primary">
                <input id="houseHasElecBill_1" type="radio" :value="false" v-model="houseHasElecBill" disabled="disabled" />
                <label for="houseHasElecBill_1">內含　</label>
              </div>
              <div class="radio-custom radio-primary">
                <input id="houseHasElecBill_2" type="radio" :value="true" v-model="houseHasElecBill" disabled="disabled" />
                <label for="houseHasElecBill_2">
                  另付
                  <input type="number" id="houseElecBill" size="10" v-model="display.houseElecBill" disabled="disabled" />
                  元
                </label>
              </div>
            </div>
          </div>
          <div class="form-group">
            <label class="col-sm-3 ">瓦　斯　費<span class="required">*</span></label>
            <div class="col-sm-9">
              <div class="radio-custom radio-primary">
                <input id="houseHasGasBill_1" type="radio" value="內含" v-model="houseHasGasBill" disabled="disabled" />
                <label for="houseHasGasBill_1">內含　</label>
              </div>
              <div class="radio-custom radio-primary">
                <input id="houseHasGasBill_2" type="radio" value="另付" v-model="houseHasGasBill" disabled="disabled" />
                <label for="houseHasGasBill_2">
                  另付
                  <input type="number" id="houseGasBill" size="10" v-model="display.houseGasBill" disabled="disabled" />
                  元　
                </label>
              <div class="radio-custom radio-primary">
                <input id="houseHasGasBill_3" type="radio" value="無" v-model="houseHasGasBill" disabled="disabled" />
                <label for="houseHasGasBill_3">無</label>
              </div>
              </div>
            </div>
          </div>
          <div class="form-group">
            <label class="col-sm-3 ">管　理　費<span class="required">*</span></label>
            <div class="col-sm-9">
              <div class="radio-custom radio-primary">
                <input id="houseHasHoa_1" type="radio" value="內含" v-model="houseHasHoa" disabled="disabled" />
                <label for="houseHasHoa_1">內含　</label>
              </div>
              <div class="radio-custom radio-primary">
                <input id="houseHasHoa_2" type="radio" value="另付" v-model="houseHasHoa" disabled="disabled" />
                <label for="houseHasHoa_2">
                  另付
                  <input type="number" id="houseHoa" size="10" v-model="display.houseHoa" disabled="disabled" />
                  元　
                </label>
              </div>
              <div class="radio-custom radio-primary">
                <input id="houseHasHoa_3" type="radio" value="無" v-model="houseHasHoa" disabled="disabled" />
                <label for="houseHasHoa_3">無</label>
              </div>
            </div>
          </div>
          <div class="form-group">
            <label class="col-sm-3 ">其 他 費 用</label>
            <div class="col-sm-9">
              <label><input type="text" id="houseOtherCost" style="width:180%;" v-model="display.houseOtherCost" disabled="disabled" /> </label>
            </div>
          </div>
        </div>
      </section>
    </div>
    <!-- 環境評估 -->
    <div class="col-md-12">
      <section class="panel">
        <header class="panel-heading">
          <div class="panel-actions">
            <a href="#" class="panel-action panel-action-toggle" data-panel-toggle></a>
          </div>
          <h1 class="panel-title">環境評估</h1>
        </header>
        <div class="panel-body">
          <div class="form-group" v-show="form.visitType=='實地訪視'">
            <label class="col-sm-3 ">有無訂定租賃契約<span class="required">*</span></label>
            <div class="col-sm-9">
              <div class="radio-custom radio-primary">
                <input id="visitIsTenancy_1" type="radio" :value="true" v-model="form.visitIsTenancy" />
                <label for="visitIsTenancy_1">有　</label>
              </div>
              <div class="radio-custom radio-primary">
                <input id="visitIsTenancy_2" type="radio" :value="false" v-model="form.visitIsTenancy" />
                <label for="visitIsTenancy_2">無</label>
              </div>
              <div v-if="form.visitIsTenancy==false">
                有無侵害學生權益
                <div class="radio-custom radio-primary">
                  <input id="visitIsTenancyBad_1" type="radio" :value="false" v-model="form.visitIsTenancyBad" />
                  <label for="visitIsTenancyBad_1">無　</label>
                </div>
                <div class="radio-custom radio-primary">
                  <input id="visitIsTenancyBad_2" type="radio" :value="true" v-model="form.visitIsTenancyBad" />
                  <label for="visitIsTenancyBad_2">有 <input type="text" v-if="form.visitIsTenancyBad" v-model="form.visitIsTenancyBadText" /></label>
                </div>
              </div>
            </div>
          </div>
          <div class="form-group" v-show="form.visitType=='實地訪視'">
            <label class="col-sm-3 ">安全設施<span class="required">*</span></label>
            <div class="col-sm-9">
              <div class="checkbox-custom chekbox-primary">
                <input id="visitSafety_1" type="checkbox" value="鐵門" v-model="form.visitSafety" />
                <label for="visitSafety_1">鐵門　</label>
              </div>
              <div class="checkbox-custom chekbox-primary">
                <input id="visitSafety_2" type="checkbox" value="鐵窗" v-model="form.visitSafety" />
                <label for="visitSafety_2">鐵窗　</label>
              </div>
              <div class="checkbox-custom chekbox-primary">
                <input id="visitSafety_3" type="checkbox" value="滅火器" v-model="form.visitSafety" />
                <label for="visitSafety_3">滅火器　</label>
              </div>
              <div class="checkbox-custom chekbox-primary">
                <input id="visitSafety_4" type="checkbox" value="逃生緩降機" v-model="form.visitSafety" />
                <label for="visitSafety_4">逃生緩降機　</label>
              </div>
              <div class="checkbox-custom chekbox-primary">
                <input id="visitSafety_5" type="checkbox" value="防火梯" v-model="form.visitSafety" />
                <label for="visitSafety_5">防火梯　</label>
              </div>
              <div class="checkbox-custom chekbox-primary">
                <input id="visitSafety_6" type="checkbox" value="警衛" v-model="form.visitSafety" />
                <label for="visitSafety_6">警衛　</label>
              </div>
              <div class="checkbox-custom chekbox-primary">
                <input id="visitSafety_7" type="checkbox" value="獨立偵煙器" v-model="form.visitSafety" />
                <label for="visitSafety_7">獨立偵煙器　</label>
              </div>
              <div class="checkbox-custom chekbox-primary">
                <input id="visitSafety_8" type="checkbox" value="監視器" v-model="form.visitSafety" />
                <label for="visitSafety_8">監視器　</label>
              </div>
              <div class="checkbox-custom chekbox-primary">
                <input id="visitSafety_9" type="checkbox" value="其他" v-model="form.visitSafety" />
                <label for="visitSafety_9">其他 <input type="text" id="visitSafetyOtherText" v-model="form.visitSafetyOtherText" v-if="form.visitSafety.includes('其他')" /></label>
              </div>
            </div>
          </div>

          <div class="form-group" v-show="form.visitType=='實地訪視'">
            <label class="col-sm-3 ">房屋格局<span class="required">*</span></label>
            <div class="col-sm-9">
              <div class="checkbox-custom chekbox-primary">
                <input id="visitRooms_1" type="checkbox" value="客廳" v-model="form.visitRooms" />
                <label for="visitRooms_1">客廳　</label>
              </div>
              <div class="checkbox-custom chekbox-primary">
                <input id="visitRooms_2" type="checkbox" value="餐廳" v-model="form.visitRooms" />
                <label for="visitRooms_2">餐廳　</label>
              </div>
              <div class="checkbox-custom chekbox-primary">
                <input id="visitRooms_3" type="checkbox" value="廚房" v-model="form.visitRooms" />
                <label for="visitRooms_3">廚房</label>
              </div>
              (可否炊爨
              <div class="radio-custom radio-primary">
                <input id="visitRoomIsKitchen_1" type="radio" :value="true" v-model="form.visitRoomIsKitchen" :disabled="!form.visitRooms.includes('廚房')" />
                <label for="visitRoomIsKitchen_1">可　</label>
              </div>
              <div class="radio-custom radio-primary">
                <input id="visitRoomIsKitchen_2" type="radio" :value="false" v-model="form.visitRoomIsKitchen" :disabled="!form.visitRooms.includes('廚房')" />
                <label for="visitRoomIsKitchen_2">否</label>
              </div>
              )　
              <div class="checkbox-custom chekbox-primary">
                <input id="visitRooms_4" type="checkbox" value="衛浴" v-model="form.visitRooms" />
                <label for="visitRooms_4">衛浴</label>
              </div>
              (
              <div class="radio-custom radio-primary">
                <input id="visitRoomIsSingalBath_1" type="radio" :value="true" v-model="form.visitRoomIsSingalBath" :disabled="!form.visitRooms.includes('衛浴')" />
                <label for="visitRoomIsSingalBath_1">獨立　</label>
              </div>
              <div class="radio-custom radio-primary">
                <input id="visitRoomIsSingalBath_2" type="radio" :value="false" v-model="form.visitRoomIsSingalBath" :disabled="!form.visitRooms.includes('衛浴')" />
                <label for="visitRoomIsSingalBath_2">共用</label>
              </div>
              )
            </div>
          </div>
          <div class="form-group" v-show="form.visitType=='實地訪視'">
            <label class="col-sm-3 ">採光照明<span class="required">*</span></label>
            <div class="col-sm-9">
              <div class="radio-custom radio-primary">
                <input id="visitLighting_1" type="radio" value="良好" v-model="form.visitLighting" />
                <label for="visitLighting_1">良好　</label>
              </div>
              <div class="radio-custom radio-primary">
                <input id="visitLighting_2" type="radio" value="尚可" v-model="form.visitLighting" />
                <label for="visitLighting_2">尚可　</label>
              </div>
              <div class="radio-custom radio-primary">
                <input id="visitLighting_3" type="radio" value="不佳" v-model="form.visitLighting" />
                <label for="visitLighting_3">不佳</label>
              </div>
            </div>
          </div>
          <div class="form-group" v-show="form.visitType=='實地訪視'">
            <label class="col-sm-3 ">生活設施與設備<span class="required">*</span></label>
            <div class="col-sm-9">
              <div class="checkbox-custom chekbox-primary">
                <input id="visitFicilities_1" type="checkbox" value="檯燈" v-model="form.visitFicilities" />
                <label for="visitFicilities_1">檯燈　</label>
              </div>
              <div class="checkbox-custom chekbox-primary">
                <input id="visitFicilities_2" type="checkbox" value="書桌椅" v-model="form.visitFicilities" />
                <label for="visitFicilities_2">書桌椅　</label>
              </div>
              <div class="checkbox-custom chekbox-primary">
                <input id="visitFicilities_3" type="checkbox" value="床鋪" v-model="form.visitFicilities" />
                <label for="visitFicilities_3">床鋪　</label>
              </div>
              <div class="checkbox-custom chekbox-primary">
                <input id="visitFicilities_4" type="checkbox" value="衣櫃" v-model="form.visitFicilities" />
                <label for="visitFicilities_4">衣櫃　</label>
              </div>
              <div class="checkbox-custom chekbox-primary">
                <input id="visitFicilities_5" type="checkbox" value="洗衣機" v-model="form.visitFicilities" />
                <label for="visitFicilities_5">洗衣機　</label>
              </div>
              <div class="checkbox-custom chekbox-primary">
                <input id="visitFicilities_6" type="checkbox" value="脫水機" v-model="form.visitFicilities" />
                <label for="visitFicilities_6">脫水機　</label>
              </div>
              <div class="checkbox-custom chekbox-primary">
                <input id="visitFicilities_7" type="checkbox" value="熱水器" v-model="form.visitFicilities" />
                <label for="visitFicilities_7">熱水器　</label>
              </div>
              <div class="checkbox-custom chekbox-primary">
                <input id="visitFicilities_8" type="checkbox" value="冷氣機" v-model="form.visitFicilities" />
                <label for="visitFicilities_8">冷氣機　</label>
              </div>
              <div class="checkbox-custom chekbox-primary">
                <input id="visitFicilities_9" type="checkbox" value="電扇" v-model="form.visitFicilities" />
                <label for="visitFicilities_9">電扇　</label>
              </div>
              <div class="checkbox-custom chekbox-primary">
                <input id="visitFicilities_10" type="checkbox" value="電視" v-model="form.visitFicilities" />
                <label for="visitFicilities_10">電視　</label>
              </div>
              <div class="checkbox-custom chekbox-primary">
                <input id="visitFicilities_11" type="checkbox" value="冰箱" v-model="form.visitFicilities" />
                <label for="visitFicilities_11">冰箱　</label>
              </div>
              <div class="checkbox-custom chekbox-primary">
                <input id="visitFicilities_12" type="checkbox" value="瓦斯爐" v-model="form.visitFicilities" />
                <label for="visitFicilities_12">瓦斯爐　</label>
              </div>
              <div class="checkbox-custom chekbox-primary">
                <input id="visitFicilities_13" type="checkbox" value="電話" v-model="form.visitFicilities" />
                <label for="visitFicilities_13">電話　</label>
              </div>
              <div class="checkbox-custom chekbox-primary">
                <input id="visitFicilities_14" type="checkbox" value="其他" v-model="form.visitFicilities" />
                <label for="visitFicilities_14">其他 <input type="text" id="visitFicilitiesOtherText" v-model="form.visitFicilitiesOtherText" v-if="form.visitFicilities.includes('其他')" /></label>
              </div>
            </div>
          </div>
          <div class="form-group" v-show="form.visitType=='實地訪視'">
            <label class="col-sm-3 ">居所環境<span class="required">*</span></label>
            <div class="col-sm-9">
              <div class="radio-custom radio-primary">
                <input id="visitNoise_1" type="radio" value="安靜" v-model="form.visitNoise" />
                <label for="visitNoise_1">安靜　</label>
              </div>
              <div class="radio-custom radio-primary">
                <input id="visitNoise_2" type="radio" value="尚可" v-model="form.visitNoise" />
                <label for="visitNoise_2">尚可　</label>
              </div>
              <div class="radio-custom radio-primary">
                <input id="visitNoise_3" type="radio" value="吵雜" v-model="form.visitNoise" />
                <label for="visitNoise_3">吵雜</label>
              </div>
            </div>
          </div>
          <div class="form-group" v-show="form.visitType=='實地訪視'">
            <label class="col-sm-3 ">通風狀況<span class="required">*</span></label>
            <div class="col-sm-9">
              <div class="radio-custom radio-primary">
                <input id="visitVentilation_1" type="radio" value="良好" v-model="form.visitVentilation" />
                <label for="visitVentilation_1">良好　</label>
              </div>
              <div class="radio-custom radio-primary">
                <input id="visitVentilation_2" type="radio" value="尚可" v-model="form.visitVentilation" />
                <label for="visitVentilation_2">尚可　</label>
              </div>
              <div class="radio-custom radio-primary">
                <input id="visitVentilation_3" type="radio" value="悶熱" v-model="form.visitVentilation" />
                <label for="visitVentilation_3">悶熱</label>
              </div>
            </div>
          </div>
          <div class="form-group" v-show="form.visitType=='實地訪視'">
            <label class="col-sm-3 ">離校距離<span class="required">*</span></label>
            <div class="col-sm-9">
              <div class="radio-custom radio-primary">
                <input id="visitSchoolDistance_1" type="radio" value="0.5公里內" v-model="form.visitSchoolDistance" />
                <label for="visitSchoolDistance_1">0.5公里內　</label>
              </div>
              <div class="radio-custom radio-primary">
                <input id="visitSchoolDistance_2" type="radio" value="1~1.5公里" v-model="form.visitSchoolDistance" />
                <label for="visitSchoolDistance_2">1~1.5公里　</label>
              </div>
              <div class="radio-custom radio-primary">
                <input id="visitSchoolDistance_3" type="radio" value="2公里" v-model="form.visitSchoolDistance" />
                <label for="visitSchoolDistance_3">2公里　</label>
              </div>
              <div class="radio-custom radio-primary">
                <input id="visitSchoolDistance_4" type="radio" value="2公里以上" v-model="form.visitSchoolDistance" />
                <label for="visitSchoolDistance_4">2公里以上</label>
              </div>
            </div>
          </div>
          <div class="form-group" v-show="form.visitType=='實地訪視'">
            <label class="col-sm-3 ">房東為人<span class="required">*</span></label>
            <div class="col-sm-9">
              <div class="radio-custom radio-primary">
                <input id="visitLandlordBehave_1" type="radio" value="熱心和善" v-model="form.visitLandlordBehave" />
                <label for="visitLandlordBehave_1">熱心和善　</label>
              </div>
              <div class="radio-custom radio-primary">
                <input id="visitLandlordBehave_2" type="radio" value="普通" v-model="form.visitLandlordBehave" />
                <label for="visitLandlordBehave_2">普通　</label>
              </div>
              <div class="radio-custom radio-primary">
                <input id="visitLandlordBehave_3" type="radio" value="挑剔苛刻" v-model="form.visitLandlordBehave" />
                <label for="visitLandlordBehave_3">挑剔苛刻　</label>
              </div>
              <div class="radio-custom radio-primary">
                <input id="visitLandlordBehave_4" type="radio" value="不清楚" v-model="form.visitLandlordBehave" />
                <label for="visitLandlordBehave_4">不清楚</label>
              </div>
            </div>
          </div>
          <div class="form-group" v-show="form.visitType=='實地訪視'">
            <label class="col-sm-3 ">環境治安情形<span class="required">*</span></label>
            <div class="col-sm-9">
              <div class="radio-custom radio-primary">
                <input id="visitPolice_1" type="radio" value="良好" v-model="form.visitPolice" />
                <label for="visitPolice_1">良好　</label>
              </div>
              <div class="radio-custom radio-primary">
                <input id="visitPolice_2" type="radio" value="普通" v-model="form.visitPolice" />
                <label for="visitPolice_2">普通　</label>
              </div>
              <div class="radio-custom radio-primary">
                <input id="visitPolice_3" type="radio" value="欠佳" v-model="form.visitPolice" />
                <label for="visitPolice_3">欠佳　</label>
              </div>
              <div class="radio-custom radio-primary">
                <input id="visitPolice_4" type="radio" value="危險" v-model="form.visitPolice" />
                <label for="visitPolice_4">危險</label>
              </div>
            </div>
          </div>
          <div class="form-group">
            <label class="col-sm-3 ">室友</label>
            <div class="col-sm-9">
              <div class="checkbox-custom chekbox-primary">
                <input id="visitRoomyType_1" type="checkbox" value="社會人士" v-model="visitRoomyType" />
                <label for="visitRoomyType_1">社會人士 <input type="number" id="visitRoomyNotSchoolmate" size="5" v-model="form.visitRoomyNotSchoolmate" :disabled="!visitRoomyType.includes('社會人士')" />人　</label>
              </div>
              <div class="checkbox-custom chekbox-primary">
                <input id="visitRoomyType_2" type="checkbox" value="本校同學或同班同學" v-model="visitRoomyType" />
                <label for="visitRoomyType_2">本校同學或同班同學 <input type="number" id="visitRoomySchoolmate" size="5" v-model="form.visitRoomySchoolmate" :disabled="!visitRoomyType.includes('本校同學或同班同學')" />人</label>
              </div>

            </div>
          </div>
          <div class="form-group" v-if="visitRoomyType.includes('本校同學或同班同學')">
            <label class="col-sm-3 ">請輸入同住同學學號</label>
            <div class="col-sm-9">
              <div style="margin-bottom: 3px;" v-for="item in visitRoomySchoolmateCount" :key="item">
                <input type="text" v-model="form.visitRoomySchoolmateStuidList[item-1]" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <!-- 總評 -->
    <div class="col-md-12">
      <section class="panel">
        <header class="panel-heading">
          <div class="panel-actions">
            <a href="#" class="panel-action panel-action-toggle" data-panel-toggle></a>
          </div>
          <h1 class="panel-title">總評</h1>
        </header>
        <div class="panel-body">
          <div class="form-group">
            <label class="col-sm-3 ">學生願意推薦此房東</label>
            <div class="col-sm-9">
              <div class="radio-custom radio-primary">
                <input id="overallStuRecommend_1" type="radio" :value="true" v-model="form.overallStuRecommend" :disabled="!isEdit" />
                <label for="overallStuRecommend_1">願意　</label>
              </div>
              <div class="radio-custom radio-primary">
                <input id="overallStuRecommend_2" type="radio" :value="false" v-model="form.overallStuRecommend" :disabled="!isEdit" />
                <label for="overallStuRecommend_2">不願意</label>
              </div>
            </div>
          </div>
          <div class="form-group">
            <label class="col-sm-3 ">師長願意推薦此房東</label>
            <div class="col-sm-9">
              <div class="radio-custom radio-primary">
                <input id="overallTchRecommend_1" type="radio" :value="true" v-model="form.overallTchRecommend" :disabled="!isEdit" />
                <label for="overallTchRecommend_1">願意　</label>
              </div>
              <div class="radio-custom radio-primary">
                <input id="overallTchRecommend_2" type="radio" :value="false" v-model="form.overallTchRecommend" :disabled="!isEdit" />
                <label for="overallTchRecommend_2">不願意</label>
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="col-sm-3 ">生活與學習情形<span class="required">*</span></div>
            <label class="col-sm-9">
              <textarea id="overallLiveStudy" rows="5" style="width:100%" v-model="form.overallLiveStudy" :disabled="!isEdit"></textarea>
            </label>
          </div>
          <div class="form-group">
            <div class="col-sm-3 ">環境安全評估<span class="required">*</span></div>
            <label class="col-sm-9">
              <textarea id="overallSafetyAssess" rows="5" style="width:100%" v-model="form.overallSafetyAssess" :disabled="!isEdit"></textarea>
            </label>
          </div>
          <div class="form-group">
            <div class="col-sm-3 ">人際關係<span class="required">*</span></div>
            <label class="col-sm-9">
              <textarea id="overallInterpersonal" rows="5" style="width:100%" v-model="form.overallInterpersonal" :disabled="!isEdit"></textarea>
            </label>
          </div>
          <div class="form-group">
            <div class="col-sm-3 ">總體評述與建議<span class="required">*</span></div>
            <label class="col-sm-9">
              <textarea id="overallSuggest" rows="5" style="width:100%" v-model="form.overallSuggest" :disabled="!isEdit"></textarea>
            </label>
          </div>
          <div class="form-group">
            <div class="col-sm-3 ">補充說明</div>
            <label class="col-sm-9">
              <textarea rows="5" style="width:100%" v-model="form.overallComment" :disabled="!isEdit"></textarea>
            </label>
          </div>
          <div class="form-group">
            <div class="col-sm-3 ">訪視合照<span class="required">*</span></div>
            <div class="col-sm-9 images-upload">
              <a href="#" @click.prevent="uploadImageClick('1')" class="btn-upload btn btn-primary">選擇檔案</a>
              <span style="color:blue;">(如有多個檔案，請一次選擇多個。)</span>
              <div v-if="preview1" style="border: 1px solid #999;margin-top: 3px;border-radius: 4px;padding: 0 5px;">
                <div>訪視合照-選擇檔案預覽 <span style="font-size: 0.8em; color: red;">(若檔案有誤，請重新選擇檔案)</span></div>
                <div style="width: 100px; height: 100px; float: left; margin: 5px;" v-for="(image, index) in preview1" :key="index">
                  <img style="max-width: 100px; max-height: 100px;" :src="image.src" />
                </div>
                <div style="clear: both;"></div>
              </div>
              <div v-if="item.picList1" style="border: 1px solid #999;margin-top: 3px;border-radius: 4px;padding: 0 5px;">
                <div>訪視合照-已上傳檔案</div>
                <div style="width: 100px; height: 100px; float: left; margin: 5px; position: relative;" v-for="(item, index) in item.picList1" :key="index">
                  <i @click.prevent="delPic(item.picId)" style="position: absolute; font-size: 26px; font-weight: bolder; color: red; font-style: normal; right: 0; top: 0; cursor: pointer;">⊗</i>
                  <img style="max-width: 100px; max-height: 100px;" :src="item.picPath" />
                </div>
                <div style="clear: both;"></div>
              </div>
              <div style="display: none;">
                <input ref="uploadImage1" type="file" accept="image/*" multiple @change="previewImage($event, '1')" />
              </div>
            </div>
          </div>
          <div class="form-group" v-show="form.visitType=='實地訪視'">
            <div class="col-sm-3 ">賃居處所安全設備或設施<span class="required">*</span></div>
            <div class="col-sm-9 images-upload">
              <a href="#" @click.prevent="uploadImageClick('2')" class="btn-upload btn btn-primary">選擇檔案</a>
              <span style="color:blue;">(如有多個檔案，請一次選擇多個。)</span>
              <div v-if="preview2" style="border: 1px solid #999;margin-top: 3px;border-radius: 4px;padding: 0 5px;">
                <div>賃居處所安全設備或設施-選擇檔案預覽 <span style="font-size: 0.8em; color: red;">(若檔案有誤，請重新選擇檔案)</span></div>
                <div style="width: 100px; height: 100px; float: left; margin: 5px;" v-for="(image, index) in preview2" :key="index">
                  <img style="max-width: 100px; max-height: 100px;" :src="image.src" />
                </div>
                <div style="clear: both;"></div>
              </div>
              <div v-if="item.picList2" style="border: 1px solid #999;margin-top: 3px;border-radius: 4px;padding: 0 5px;">
                <div>賃居處所安全設備或設施-已上傳檔案</div>
                <div style="width: 100px; height: 100px; float: left; margin: 5px; position: relative;" v-for="(item, index) in item.picList2" :key="index">
                  <i @click.prevent="delPic(item.picId)" style="position: absolute; font-size: 26px; font-weight: bolder; color: red; font-style: normal; right: 0; top: 0; cursor: pointer;">⊗</i>
                  <img style="max-width: 100px; max-height: 100px;" :src="item.picPath" />
                </div>
                <div style="clear: both;"></div>
              </div>
              <div style="display: none;">
                <input ref="uploadImage2" type="file" accept="image/*" multiple @change="previewImage($event, '2')" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <div class="col-md-4 col-md-offset-4" v-if="isEdit">
      <table style="margin:6px;text-align: center">
        <tr>
          <td >
            <a v-if="item.isSave" href="#" @click.prevent="formClear" class="btn-upload btn" style="background-color:#666; border-color:#999; color:#FFF;">重　　填</a>　</td>
          <td >
            <a v-if="item.isSave || isAdmin('tenancy')" href="#" @click.prevent="formSubmit" class="btn-upload btn" style="background-color:#337AB7; border-color:#2E6DA4; color:#FFF;">儲　　存</a>
            <a v-if="(!item.id || item.isTemp) && (item.isSave || isAdmin('tenancy'))" href="#" @click.prevent="formSubmitTemp" class="btn-upload btn" style="background-color:#337AB7; border-color:#2E6DA4; color:#FFF;">暫　　存</a>
          </td>
        </tr>
      </table>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      pageAdmin: false,
      loginInfo: {},
      opening: {
        startDate: null,
        endDate: null,
        smtr: null,
      },
      isEdit: true,
      item: {},
      cityList: [],
      areaList: [],
      addrAreaList: [],
      houseHasDeposit: null,
      houseHasWaterBill: null,
      houseHasElecBill: null,
      houseHasGasBill: null,
      houseHasHoa: null,
      visitRoomyType: [],
      preview1: null,
      preview2: null,
      form: {
        schYearTerm: null,
        studentId: null,
        addrCityId: null,
        addrAreaId: null,
        addr: null,
        landlordName: null,
        landlordJob: null,
        landlordPhoneType: null,
        landlordPhone: "",
        visitType: null,
        houseDeposit: null,
        visitIsTenancy: null,
        visitIsTenancyBad: null,
        visitIsTenancyBadText: null,
        visitSafety: [],
        visitSafetyOtherText: null,
        visitRooms: [],
        visitRoomIsKitchen: null,
        visitRoomIsSingalBath: null,
        visitLighting: null,
        visitFicilities: [],
        visitFicilitiesOtherText: null,
        visitNoise: null,
        visitVentilation: null,
        visitSchoolDistance: null,
        visitLandlordBehave: null,
        visitPolice: null,
        visitRoomyNotSchoolmate: null,
        visitRoomySchoolmate: null,
        visitRoomySchoolmateStuidList: [],
        overallStuRecommend: null,
        overallTchRecommend: null,
        overallLiveStudy: null,
        overallSafetyAssess: null,
        overallInterpersonal: null,
        overallSuggest: null,
        overallComment: null,
        isTemp: false,
        delPicList: []
      },
      display: {
        check_1_1: null,
        check_1_2: null,
        check_1_3: null,
        check_1_4: null,
        check_1_5: null,
        check_1_6: null,
        check_1_7: null,
        check_1_8: null,
        check_1_9: null,
        check_1_10: null,
        check_1_11: null,
        check_1_12: null,
        check_2_1: null,
        check_2_2: null,
        check_2_3: null,
        check_2_4: null,
        check_2_5: null,
        check_2_6: null,
        check_3_1: null,
        check_3_2: null,
        check_3_3: null,
        check_3_4: null,
        check_3_5: null,
        check_4_1: null,
        check_4_2: null,
        check_4_3: null,
        check_4_4: null,
        check_4_5: null,
        check_4_6: null,
        check_4_7: null,
        check_5_1: null,
        check_5_2: null,
        check_5_3: null,
        check_5_4: null,
        check_5_5: null,
        check_5_6: null,
        check_5_7: null,
        check_5_8: null,
        check_6_1: null,
        check_6_2: null,
        check_6_3: null,
        check_6_4: null,
        check_7_1: null,
        check_7_2: null,
        checkScore: null,
        houseType: null,
        houseTypeOtherText: null,
        houseBuild: null,
        houseRoom: null,
        houseStructure: null,
        houseTotalFloor: null,
        houseFloor: null,
        houseAge: null,
        houseFootage: null,
        houseRentType: null,
        houseRent: null,
        houseWaterBill: null,
        houseElecBill: null,
        houseGasBill: null,
        houseHoa: null,
        houseOtherCost: null,
      }
    };
  },
  computed: {
    schYearTerm() {
      return this.$route.params.year.replace("|", "/");
    },
    stuId() {
      return this.$route.params.id;
    },
    visitRoomySchoolmateCount() {
      if (!this.form.visitRoomySchoolmate) return 1;
      let result = parseInt(this.form.visitRoomySchoolmate);
      if (result == NaN) return 1;
      if (result <= 0) return 1;
      return parseInt(this.form.visitRoomySchoolmate);
    }
  },
  async mounted() {
    this.form.schYearTerm = this.schYearTerm.replace("/", "");
    this.form.studentId = this.stuId;
    
    // 檢查權限和開放時間
    this.pageAdmin = await this.isAdmin("tenancy");
    let d = this.nowDate();
    let r = await new Promise(resolve => {
      this.$http.get("/api/shared/login-info").then(a => {
        this.loginInfo = a.body;
        this.$http.get("/api/tenancyVisit/opening-date").then(b => {
          if (b.body) {
            this.opening.startDate = b.body.startDate;
            this.opening.endDate = b.body.endDate;
            this.opening.smtr = b.body.smtr;
          }
          if (!this.pageAdmin) {
            // 檢查學年度學期是否符合
            if (this.form.schYearTerm.replace("/", "") != this.opening.smtr) {
              this.isEdit = false;
            }
            // 檢查開放時間
            if (this.opening.startDate == "" || this.opening.endDate == "") {
              this.isEdit = false;
            } else {
              let sd = new Date(this.opening.startDate);
              let ed = new Date(this.opening.endDate);
              ed.setDate(ed.getDate() + 1);
              if (d < sd || d > ed) {
                this.isEdit = false;
              }
            }
          }
            resolve(true);
        });
      });
    });
    if (!r) return false;
    
    this.$http.get("/api/shared/city-list").then((a) => {
      this.cityList = a.body;
      this.$http.get("/api/shared/area-list").then((a) => {
        this.areaList = a.body;
        this.load();
      });
    });
  },
  methods: {
    addrCityChange() {
      if (this.form.addrCityId) {
        this.addrAreaList = this.areaList.filter((item) => {
          return item.cityId == this.form.addrCityId;
        });
      } else {
        this.addrAreaList = [];
      }
      this.form.addrAreaId = null;
    },
    load() {
      this.visitRoomyType = [];
      this.$http
        .get("/api/tenancyVisit/edit", {
          params: {
            schYearTerm: this.schYearTerm.replace("/", ""),
            stuId: this.stuId
          }
        })
        .then(a => {
          this.item = a.body;
          this.form.addrCityId = this.item.addrCityId;
          if (this.form.addrCityId) this.addrCityChange();
          this.form.addrAreaId = this.item.addrAreaId;
          this.form.addr = this.item.addr;
          this.form.landlordName = this.item.landlordName;
          this.form.landlordJob = this.item.landlordJob;
          this.form.landlordPhoneType = this.item.landlordPhoneType;
          this.form.landlordPhone = this.item.landlordPhone;
          this.form.visitType = this.item.visitType;
          this.display.check_1_1 = this.item.check_1_1;
          this.display.check_1_2 = this.item.check_1_2;
          this.display.check_1_3 = this.item.check_1_3;
          this.display.check_1_4 = this.item.check_1_4;
          this.display.check_1_5 = this.item.check_1_5;
          this.display.check_1_6 = this.item.check_1_6;
          this.display.check_1_7 = this.item.check_1_7;
          this.display.check_1_8 = this.item.check_1_8;
          this.display.check_1_9 = this.item.check_1_9;
          this.display.check_1_10 = this.item.check_1_10;
          this.display.check_1_11 = this.item.check_1_11;
          this.display.check_1_12 = this.item.check_1_12;
          this.display.check_2_1 = this.item.check_2_1;
          this.display.check_2_2 = this.item.check_2_2;
          this.display.check_2_3 = this.item.check_2_3;
          this.display.check_2_4 = this.item.check_2_4;
          this.display.check_2_5 = this.item.check_2_5;
          this.display.check_2_6 = this.item.check_2_6;
          this.display.check_3_1 = this.item.check_3_1;
          this.display.check_3_2 = this.item.check_3_2;
          this.display.check_3_3 = this.item.check_3_3;
          this.display.check_3_4 = this.item.check_3_4;
          this.display.check_3_5 = this.item.check_3_5;
          this.display.check_4_1 = this.item.check_4_1;
          this.display.check_4_2 = this.item.check_4_2;
          this.display.check_4_3 = this.item.check_4_3;
          this.display.check_4_4 = this.item.check_4_4;
          this.display.check_4_5 = this.item.check_4_5;
          this.display.check_4_6 = this.item.check_4_6;
          this.display.check_4_7 = this.item.check_4_7;
          this.display.check_5_1 = this.item.check_5_1;
          this.display.check_5_2 = this.item.check_5_2;
          this.display.check_5_3 = this.item.check_5_3;
          this.display.check_5_4 = this.item.check_5_4;
          this.display.check_5_5 = this.item.check_5_5;
          this.display.check_5_6 = this.item.check_5_6;
          this.display.check_5_7 = this.item.check_5_7;
          this.display.check_5_8 = this.item.check_5_8;
          this.display.check_6_1 = this.item.check_6_1;
          this.display.check_6_2 = this.item.check_6_2;
          this.display.check_6_3 = this.item.check_6_3;
          this.display.check_6_4 = this.item.check_6_4;
          this.display.check_7_1 = this.item.check_7_1;
          this.display.check_7_2 = this.item.check_7_2;
          this.display.checkScore = this.item.checkScore;
          this.display.houseType = this.item.houseType;
          this.display.houseTypeOtherText = this.item.houseTypeOtherText;
          this.display.houseBuild = this.item.houseBuild;
          this.display.houseRoom = this.item.houseRoom;
          this.display.houseStructure = this.item.houseStructure;
          this.display.houseTotalFloor = this.item.houseTotalFloor;
          this.display.houseFloor = this.item.houseFloor;
          this.display.houseAge = this.item.houseAge;
          this.display.houseFootage = this.item.houseFootage;
          this.display.houseRentType = this.item.houseRentType;
          this.display.houseRent = this.item.houseRent;
          if (this.item.registerId) {
            this.houseHasDeposit = this.item.houseDeposit != null;
            this.houseHasWaterBill = this.item.houseWaterBill != null;
            this.houseHasElecBill = this.item.houseElecBill != null;
            this.houseHasGasBill = this.item.houseNoGasBill ? "無" : this.item.houseGasBill == null ? "內含" : "另付";
            this.houseHasHoa = this.item.houseNoHoa ? "無" : this.item.houseHoa == null ? "內含" : "另付";
          } else {
            this.houseHasDeposit = null;
            this.houseHasWaterBill = null;
            this.houseHasElecBill = null;
            this.houseHasGasBill = null;
            this.houseHasHoa = null;
          }
          this.form.houseDeposit = this.item.houseDeposit;
          this.display.houseWaterBill = this.item.houseWaterBill;
          this.display.houseElecBill = this.item.houseElecBill;
          this.display.houseGasBill = this.item.houseGasBill;
          this.display.houseHoa = this.item.houseHoa;
          this.display.houseOtherCost = this.item.houseOtherCost;
          this.form.visitIsTenancy = this.item.visitIsTenancy;
          this.form.visitIsTenancyBad = this.item.visitIsTenancyBad;
          this.form.visitIsTenancyBadText = this.item.visitIsTenancyBadText;
          if (this.item.visitSafety)
            this.form.visitSafety = this.item.visitSafety.split(";");
          else
            this.form.visitSafety = [];
          this.form.visitSafetyOtherText = this.item.visitSafetyOtherText;
          if (this.item.visitRooms)
            this.form.visitRooms = this.item.visitRooms.split(";");
          else
            this.form.visitRooms = [];
          this.form.visitRoomIsKitchen = this.item.visitRoomIsKitchen;
          this.form.visitRoomIsSingalBath = this.item.visitRoomIsSingalBath;
          this.form.visitLighting = this.item.visitLighting;
          if (this.item.visitFicilities)
            this.form.visitFicilities = this.item.visitFicilities.split(";");
          else
            this.form.visitFicilities = [];
          this.form.visitFicilitiesOtherText = this.item.visitFicilitiesOtherText;
          this.form.visitNoise = this.item.visitNoise;
          this.form.visitVentilation = this.item.visitVentilation;
          this.form.visitSchoolDistance = this.item.visitSchoolDistance;
          this.form.visitLandlordBehave = this.item.visitLandlordBehave;
          this.form.visitPolice = this.item.visitPolice;
          this.form.visitRoomyNotSchoolmate = this.item.visitRoomyNotSchoolmate;
          if (this.item.visitRoomyNotSchoolmate)
            this.visitRoomyType.push("社會人士");
          this.form.visitRoomySchoolmate = this.item.visitRoomySchoolmate;
          if (this.item.visitRoomySchoolmate)
            this.visitRoomyType.push("本校同學或同班同學");
          if (this.item.visitRoomySchoolmateStuidList)
            this.form.visitRoomySchoolmateStuidList = this.item.visitRoomySchoolmateStuidList.split(";");
          else
            this.form.visitRoomySchoolmateStuidList = [];
          this.form.overallStuRecommend = this.item.overallStuRecommend;
          this.form.overallTchRecommend = this.item.overallTchRecommend;
          this.form.overallLiveStudy = this.item.overallLiveStudy;
          this.form.overallSafetyAssess = this.item.overallSafetyAssess;
          this.form.overallInterpersonal = this.item.overallInterpersonal;
          this.form.overallSuggest = this.item.overallSuggest;
          this.form.overallComment = this.item.overallComment;
          if (!this.item.picList1) this.item.picList1 = [];
          if (!this.item.picList2) this.item.picList2 = [];
        });
    },
    uploadImageClick(type) {
      switch (type) {
        case "1":
          $(this.$refs.uploadImage1).click();
          break;
        case "2":
          $(this.$refs.uploadImage2).click();
          break;
      }
    },
    formClear() {
      $(this.$refs.uploadImage1).val("");
      $(this.$refs.uploadImage2).val("");
      this.preview1 = null;
      this.preview2 = null;
      this.load();
    },
    async formSubmitTemp() {
      if (!confirm("您點選的是『暫存』按鈕，請問是否確認？")) return;
      this.form.isTemp = true;
      if (this.form.overallLiveStudy == null) this.form.overallLiveStudy = "";
      if (this.form.overallSafetyAssess == null) this.form.overallSafetyAssess = "";
      if (this.form.overallInterpersonal == null) this.form.overallInterpersonal = "";
      if (this.form.overallSuggest == null) this.form.overallSuggest = "";
      await this.submitPost();
    },
    async formSubmit() {
      if (this.checkForm() == false) return;
      let checkStuIdList = await this.$http.post(
        "/api/shared/check-stuid-list",
        this.form.visitRoomySchoolmateStuidList
      );
      if (checkStuIdList.body.status == false) {
        let msg = "";
        checkStuIdList.body.errorList.forEach(err => {
          msg += "『" + err + "』、";
        });
        alert(
          "『同住同學學號』欄位中：" +
            msg.substr(0, msg.length - 1) +
            " 查無該學號之學生資料"
        );
        return false;
      }
      await this.submitPost();
    },
    async submitPost() {
      let a = await this.$http.post("/api/tenancyVisit/edit/", this.form);
      if (a.body.status) {
        if (
          this.$refs.uploadImage1.files.length > 0 ||
          this.$refs.uploadImage2.files.length > 0
        ) {
          let formData = new FormData();
          formData.append("idList", a.body.idList);
          if (this.$refs.uploadImage1.files.length > 0) {
            for (var i = 0, f; (f = this.$refs.uploadImage1.files[i]); i++) {
              formData.append("pic1", f);
            }
          } else {
            formData.append("pic1", this.$refs.uploadImage1.files[0]);
          }
          if (this.$refs.uploadImage2.files.length > 0) {
            for (var i = 0, f; (f = this.$refs.uploadImage2.files[i]); i++) {
              formData.append("pic2", f);
            }
          } else {
            formData.append("pic2", this.$refs.uploadImage2.files[0]);
          }
          let b = await this.$http.post(
            "/api/tenancyVisit/upload-image",
            formData,
            {
              headers: { "Content-Type": "multipart/form-data" }
            }
          );
          if (b.body.status) {
            alert("儲存成功" + a.body.msg);
            this.$router.push("/tenancy-visit");
          } else {
            alert("儲存失敗:" + b.body.msg);
            console.log(a.body.exstr);
          }
        } else {
          alert("儲存成功" + a.body.msg);
          this.$router.push("/tenancy-visit");
        }
      } else {
        alert(a.body.msg);
        console.log(a.body.exstr);
      }
    },
    checkForm() {
      let focus = true;
      let msg = "";
      if (!this.form.addrCityId || !this.form.addrAreaId || !this.form.addr) msg += "『賃居地址』、";
      if (!this.form.landlordName) msg += "『房東姓名』、";
      if (!this.form.landlordPhoneType || (this.form.landlordPhoneType == "聯絡電話" && !this.form.landlordPhone)) msg += "『房東電話』、";
      if (!this.form.landlordJob) msg += "『房東職業』、";
      if (!this.form.visitType) {
        msg += "『訪視方式』、";
        if (focus) { $("#visitType_1").focus(); focus = false; }
      }
      if (this.form.visitType == "實地訪視") {
        if (this.houseHasDeposit == true && !this.form.houseDeposit) {
          msg += "『租屋環境及設施-押金』、";
          if (focus) { $("#houseDeposit").focus(); focus = false; }
        }
        if (
          this.form.visitIsTenancy == null ||
          (this.form.visitIsTenancy == false &&
            this.form.visitIsTenancyBad == null) ||
          (this.form.visitIsTenancyBad == true &&
            !this.form.visitIsTenancyBadText)
        ) {
          msg += "『環境評估-有無訂定租賃契約』、";
          if (focus) { $("#visitIsTenancy_1").focus(); focus = false; }
        }
        if (
          this.form.visitSafety.includes("其他") &&
          !this.form.visitSafetyOtherText
        ) {
          msg += "『環境評估-安全設施-其他-文字描述』、";
          if (focus) { $("#visitSafetyOtherText").focus(); focus = false; }
        }
        if (
          this.form.visitRooms.includes("廚房") &&
          this.form.visitRoomIsKitchen == null
        ) {
          msg += "『環境評估-房屋格局-廚房』、";
          if (focus) { $("#visitRoomIsKitchen_1").focus(); focus = false; }
        }
        if (
          this.form.visitRooms.includes("衛浴") &&
          this.form.visitRoomIsSingalBath == null
        ) {
          msg += "『環境評估-房屋格局-衛浴』、";
          if (focus) { $("#visitRoomIsSingalBath_1").focus(); focus = false; }
        }
        if (!this.form.visitLighting) {
          msg += "『環境評估-採光照明』、";
          if (focus) { $("#visitLighting_1").focus(); focus = false; }
        }
        if (
          this.form.visitFicilities.includes("其他") &&
          !this.form.visitFicilitiesOtherText
        ) {
          msg += "『環境評估-生活設施與設備-其他-文字描述』、";
          if (focus) { $("#visitFicilitiesOtherText").focus(); focus = false; }
        }
        if (!this.form.visitNoise) {
          msg += "『環境評估-居所環境』、";
          if (focus) { $("#visitNoise_1").focus(); focus = false; }
        }
        if (!this.form.visitVentilation) {
          msg += "『環境評估-通風狀況』、";
          if (focus) { $("#visitVentilation_1").focus(); focus = false; }
        }
        if (!this.form.visitSchoolDistance) {
          msg += "『環境評估-離校距離』、";
          if (focus) { $("#visitSchoolDistance_1").focus(); focus = false; }
        }
        if (!this.form.visitLandlordBehave) {
          msg += "『環境評估-房東為人』、";
          if (focus) { $("#visitLandlordBehave_1").focus(); focus = false; }
        }
        if (!this.form.visitPolice) {
          msg += "『環境評估-環境治安情形』、";
          if (focus) { $("#visitPolice_1").focus(); focus = false; }
        }
      }
      // if (this.form.overallStuRecommend == null) {
      //   msg += "『總評-學生願意推薦此房東』、";
      //   if (focus) { $("#overallStuRecommend_1").focus(); focus = false; }
      // }
      // if (this.form.overallTchRecommend == null) {
      //   msg += "『總評-師長願意推薦此房東』、";
      //   if (focus) { $("#overallTchRecommend_1").focus(); focus = false; }
      // }
      if (!this.form.overallLiveStudy) {
        msg += "『總評-生活與學習情形』、";
        if (focus) { $("#overallLiveStudy").focus(); focus = false; }
      }
      if (!this.form.overallSafetyAssess) {
        msg += "『總評-環境安全評估』、";
        if (focus) { $("#overallSafetyAssess").focus(); focus = false; }
      }
      if (!this.form.overallInterpersonal) {
        msg += "『總評-人際關係』、";
        if (focus) { $("#overallInterpersonal").focus(); focus = false; }
      }
      if (!this.form.overallSuggest) {
        msg += "『總評-總體評述與建議』、";
        if (focus) { $("#overallSuggest").focus(); focus = false; }
      }
      if (
        this.$refs.uploadImage1.files.length == 0 &&
        this.item.picList1.length == 0
      ) {
        msg += "『訪視合照』、";
        if (focus) { $(this.$refs.uploadImage1).focus(); focus = false; }
      }
      if (
        this.form.visitType == "實地訪視" &&
        this.$refs.uploadImage2.files.length == 0 &&
        this.item.picList2.length == 0
      ) {
        msg += "『賃居處所安全設備或設施』、";
        if (focus) { $(this.$refs.uploadImage2).focus(); focus = false; }
      }

      if (msg != "") {
        alert(msg.substr(0, msg.length - 1) + " 尚未選取或填寫");
        return false;
      }

      if (this.form.visitType == "實地訪視") {
        if (this.houseHasDeposit == false) this.form.houseDeposit = null;
        if (this.form.visitIsTenancyBad == false)
          this.form.visitIsTenancyBadText = null;
        if (!this.form.visitSafety.includes("其他"))
          this.form.visitSafetyOtherText = null;
        if (!this.form.visitRooms.includes("廚房"))
          this.form.visitRoomIsKitchen = null;
        if (!this.form.visitRooms.includes("衛浴"))
          this.form.visitRoomIsSingalBath = null;
        if (!this.form.visitFicilities.includes("其他"))
          this.form.visitFicilitiesOtherText = null;

        if (this.visitRoomyType.includes('社會人士')) {
          if (!this.form.visitRoomyNotSchoolmate) {
            alert("『室友-社會人士』已勾選，請確實填寫人數資料");
            $("#visitRoomyNotSchoolmate").focus();
            return false;
          }
        } else {
          this.form.visitRoomyNotSchoolmate = null;
        }
        if (this.visitRoomyType.includes('本校同學或同班同學')) {
          if (!this.form.visitRoomySchoolmate) {
            alert("『室友-本校同學或同班同學』已勾選，請確實填寫人數資料");
            $("#visitRoomySchoolmate").focus();
            return false;
          }
          if (this.form.visitRoomySchoolmateStuidList.length > this.form.visitRoomySchoolmate) {
            let length = this.form.visitRoomySchoolmateStuidList.length;
            this.form.visitRoomySchoolmateStuidList.splice(this.form.visitRoomySchoolmate, length - this.form.visitRoomySchoolmate);
          }
          if (this.form.visitRoomySchoolmateStuidList.some(a => a === this.stuId)) {
            alert("『同住同學學號』輸入錯誤，請勿輸入目前資料之學生學號");
            return false;
          }
        } else {
          this.form.visitRoomySchoolmate = null;
          this.form.visitRoomySchoolmateStuidList = [];
        }
      } else {
        this.form.houseDeposit = null;
        this.form.visitIsTenancy = null;
        this.form.visitIsTenancyBad = null;
        this.form.visitIsTenancyBadText = null;
        this.form.visitSafety = [];
        this.form.visitSafetyOtherText = null;
        this.form.visitRooms = [];
        this.form.visitRoomIsKitchen = null;
        this.form.visitRoomIsSingalBath = null;
        this.form.visitLighting = null;
        this.form.visitFicilities = [];
        this.form.visitFicilitiesOtherText = null;
        this.form.visitNoise = null;
        this.form.visitVentilation = null;
        this.form.visitSchoolDistance = null;
        this.form.visitLandlordBehave = null;
        this.form.visitPolice = null;
        this.form.visitRoomyNotSchoolmate = null;
        this.form.visitRoomySchoolmate = null;
        this.form.visitRoomySchoolmateStuidList = [];
      }

      return true;
    },
    errorFocus(check, dom) {
      if (!check) {

      }
    },
    previewImage(event, type) {
      const files = event.target.files;
      switch (type) {
        case "1":
          this.preview1 = [];
          [].forEach.call(files, this.fileReader1);
          break;
        case "2":
          this.preview2 = [];
          [].forEach.call(files, this.fileReader2);
          break;
      }
    },
    fileReader1(file) {
      const reader = new FileReader();
      reader.addEventListener("load", this.createImage1);
      reader.readAsDataURL(file);
    },
    createImage1(event) {
      const file = event.target;
      const image = { title: file.name, src: file.result };
      this.preview1.push(image);
    },
    fileReader2(file) {
      const reader = new FileReader();
      reader.addEventListener("load", this.createImage2);
      reader.readAsDataURL(file);
    },
    createImage2(event) {
      const file = event.target;
      const image = { title: file.name, src: file.result };
      this.preview2.push(image);
    },
    delPic(id) {
      if (!confirm("是否確認刪除這張照片？")) return;
      this.form.delPicList.push(id);
      this.item.picList1 = this.item.picList1.filter(a => {
        return !this.form.delPicList.some(b => b == a.picId);
      });
      this.item.picList2 = this.item.picList2.filter(a => {
        return !this.form.delPicList.some(b => b == a.picId);
      });
    }
  }
};
</script>

<style scoped>
div.radio-custom,
div.checkbox-custom {
  display: inline-block;
}
label.check-score {
  font-weight: bold;
  color: red;
  margin-left: 10px;
}
</style>
